<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Price list') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12" style="max-height: 500px; overflow-y: scroll;">
          <table>
            <thead v-if="smsPrices.length > 1">
              <tr>
                <th>{{ _('Country') }}</th>
                <th>{{ _('Network') }}</th>
                <th style="text-align: right">{{ _('Price') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="price in smsPrices">
                <td>{{ price.country }}</td>
                <td>{{ price.network }}</td>
                <td style="text-align: right">{{ $filters.currency(price.price) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
    </div>
  </div>
</template>

<script>
import errors from '~/lib/errors'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  mixins: [errors],
  data () {
    return {
      smsPrices: []
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'locale', 'apiKey']),
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    loadSMSPrices() {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/smspricelist.json?apikey=' + this.apiKey)
        } catch(e) {
          resolve([{ country: this._('There was an unknown error.') }])
          return
        }
        resolve(response.data)
      })
    },
  },
  async mounted() {
    this.smsPrices = await this.loadSMSPrices()
  }
}
</script>